module.exports = __webpack_public_path__ + "static/media/pipa-capa.21398c99.png";